export default __webpack_public_path__ + "static/media/giphy.2368aa58.gif";